export enum DashboardProjectActionUiEnum {
  PREVIEW = 'PREVIEW',
  COPY_LINK = 'COPY_LINK',
  GO_TO_PROJECT = 'GO_TO_PROJECT',
}
